module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner",
    class: [_vm.color, _vm.size],
    attrs: {
      "role": "status",
      "aria-label": _vm.$t('vue2.a11y.loading')
    }
  }, [_c('div', {
    staticClass: "bounce1",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8029c268!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Spinner.vue
// module id = 2044
// module chunks = 1